export type ISubmitDataWorkflow = (
  submitUrl: string,
  form: HTMLFormElement,
  successMsg: string
) => void;

export function submitDataWorkflow(
  submitUrl: string,
  form: HTMLFormElement,
  successMsg: string
): void {
  const $missingApprove = $('#missingApprove');
  const $missingSignature = $('#missingSignature');
  const $agreement = $('#agreement');

  let isValid = true;
  let dataString;

  $missingApprove.addClass('hide');
  $missingSignature.addClass('hide');

  if (form.accepted.value.toString() === 'true') {
    if (form.approve && !form.approve.checked) {
      $missingApprove.removeClass('hide');
      isValid = false;
    }
    if (
      form.signatureValue &&
      (form.signatureValue.value === null || form.signatureValue.value.toString() === '')
    ) {
      $missingSignature.removeClass('hide');
      isValid = false;
    }
  }

  if (isValid) {
    dataString = `stepId=${form.stepId.value}&approve=${form.approve.value}&accepted=${form.accepted.value}&comment=${form.comment.value}`;
    if (form.signatureValue) {
      dataString += `&signatureValue=${form.signatureValue.value}`;
    }
    // alert (dataString);return false;
    $.post(submitUrl, dataString).done(() => {
      $agreement.addClass('hide');
      $(`#${successMsg}`).removeClass('hide');
    });
  }
}
